/* tslint:disable */
/* eslint-disable */
import { OpenAiChatRequestDisplayModel as AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel } from '../../../../../../../ace/xFound/Portal/Core/CAQ/Models/open-ai-chat-request-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { OpenAiChatRequestDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModelFormGroup } from '@/api/model-index';

export interface IGetChatCompletionQuery {
  chatMessageList?: null | Array<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>;
  url?: null | string;
}
export class GetChatCompletionQuery extends BaseModel implements IGetChatCompletionQuery {
  chatMessageList?: null | Array<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>;
  url?: null | string;
}

